<template>
  <v-container
    :id="`${displayAsPlural.toLowerCase().replaceAll(' ', '-')}-view`"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="primary"
          :icon="appItem.icon"
          :icon-small="true"
        >
          <template #title>
            <v-container class="py-0">
              <v-row>
                <v-col sm="8">
                  <h3>{{ displayAsSingular }} Maintenance</h3>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <v-form>
            <v-container
              class="py-0 pb-5"
            >
              <v-row
                align="end"
                no-gutters
              >
                <v-col
                  cols="12"
                  sm="12"
                  lg="5"
                >
                  <v-container>
                    <v-row
                      v-if="customers.data.length > 1"
                      no-gutters
                    >
                      <v-col
                        cols="12"
                      >
                        <select-customer
                          id="2-maintain-customer"
                          v-model="customers.selectedItem"
                          :appendhint="`to select from its ${displayAsPluralPlan}`"
                        />
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="12"
                      >
                        <select-plan
                          id="2-maintain-plan"
                          v-model="plans.selectedItem"
                          :appendhint="`to select from its ${displayAsPluralDivision}`"
                        />
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col
                        cols="12"
                      >
                        <select-division
                          id="2-maintain-division"
                          v-model="divisions.selectedItem"
                          :appendhint="`to view its ${displayAsPlural}`"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>

              <v-row
                no-gutters
              >
                <v-col
                  cols="12"
                  class="text-left"
                >
                  <assembly-table
                    ref="maintenanceAssemblyTable"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { get } from 'vuex-pathify'
  import MaterialCard from '@/components/MaterialCard'
  import SelectPlan from '@/components/keys/SelectPlan'
  import SelectDivision from '@/components/keys/SelectDivision'
  import AssemblyTable from '@/components/maintenance/tables/AssemblyTable'

  export default {
    name: 'AssembliesView',

    components: {
      MaterialCard,
      SelectPlan,
      SelectDivision,
      AssemblyTable,
    },

    data () {
      return {
        appItem: null,
      }
    },

    computed: {
      ...mapGetters('app', [
        'getAppItem',
      ]),
      users: get('user/users'),
      customers: get('customer/customers'),
      plans: get('plan/plans'),
      divisions: get('division/divisions'),
      displayAsPluralPlan: get('plan/displayAsPlural'),
      displayAsPluralDivision: get('division/displayAsPlural'),
      displayAsSingular: get('assembly/displayAsSingular'),
      displayAsPlural: get('assembly/displayAsPlural'),
    },

    created () {
      this.appItem = this.getAppItem(this.$options.name)
      this.$store.dispatch('user/setPageName', this.$options.name)
    },
  }
</script>
